module.exports = __webpack_public_path__ + "static/img/banner1.4542f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad/banner1.png
// module id = e+2s
// module chunks = 1